import React from 'react';
import { useAddThemeCssToDom } from './useAddThemeCssToDom';

const ThemeCssFetcher = () => {
  useAddThemeCssToDom();

  return <></>;
};

export default ThemeCssFetcher;
